var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuantifyLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 371.144 371.144",
    style: {
      enableBackground: "new 0 0 371.144 371.144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.47,
    y: 150.544,
    style: {
      fill: "#00EFD1"
    },
    width: 69.486,
    height: 217.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.111,
    y: 232.569,
    style: {
      fill: "#00EFD1"
    },
    width: 69.486,
    height: 135.419
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.229,
    y: 283.246,
    style: {
      fill: "#00EFD1"
    },
    width: 69.486,
    height: 84.637
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083863"
    },
    d: "M368.449,13.662c-1.589-2.19-4.089-3.536-6.792-3.657l-95.086-6.792 c-5.451-0.583-10.343,3.363-10.926,8.814c-0.021,0.196-0.036,0.393-0.045,0.59c-0.603,5.739,3.561,10.881,9.3,11.483 c0.035,0.004,0.069,0.007,0.104,0.01l67.396,4.702l-123.82,96.653l-94.563-74.188c-4.038-3.197-9.803-2.976-13.584,0.522 L3.258,144.797c-4.131,3.919-4.364,10.425-0.522,14.629c1.864,2.419,4.786,3.783,7.837,3.657c2.756-0.039,5.385-1.166,7.314-3.135 l90.384-86.727l93.518,73.665c3.817,3.056,9.244,3.056,13.061,0l133.747-104.49l-5.224,65.306 c-0.026,5.674,4.279,10.431,9.927,10.971h0.522c5.386,0.027,9.91-4.045,10.449-9.404l6.792-88.294 C371.445,18.258,370.469,15.523,368.449,13.662z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantifyLight);
export default __webpack_public_path__ + "static/media/QuantifyLight.84b99f10.svg";
export { ForwardRef as ReactComponent };